<template>
  <div class="plv-ia--lottery-winner">
    <ul v-if="list.length > 0"
        ref="winnersListEl"
        class="plv-ia-lottery__winner__list"
        @scroll="listScroll">
      <li class="winner-list__head">
        {{ t('plvIA.lottery.winnersList') }}
      </li>
      <li
        v-for="(item, index) in list"
        :key="index"
        :class="{ 'lottery-only-one-list': winnerList.length <= 3 }"
      >
        <span v-for="i in item" :key="i.viewerName + index">{{
          i.viewerName
        }}</span>
      </li>
    </ul>
    <div v-else class="plv-ia-lottery__winner__list plv-ia-lottery-template-table-empty">
      <img src="./images/no-list.png" alt=""/>
      <p>{{ t('plvIA.lottery.noWinner') }}</p>
    </div>
    <div class="plv-ia__lottery-btn-group">
      <button class="plv-ia-lottery-btn" @click="closeLottery">
        {{ t('plvIA.lottery.back') }}
      </button>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
export default {
  name: 'LotteryWinner',
  mixins: [Locale],
  props: {
    core: Object,
    // 抽奖记录
    lotteryRecord: Object
  },
  data() {
    return {
      winnerList: [],
      page: 1,
      totalPages: null
    };
  },
  computed: {
    list() {
      return this.changeAry(this.winnerList);
    }
  },
  mounted() {
    this.page = 1;
    this.getWinnersList();
  },
  methods: {
    async getWinnersList() {
      const { totalPages, page } = this;
      if ((totalPages != null && page > totalPages) || this.fetchWinnerList) return;
      this.fetchWinnerList = true;
      try {
        const result = await this.core.getWinnersList(page, this.lotteryRecord.lotteryId);
        this.winnerList = this.winnerList.concat(result.contents);
        this.totalPages = result.totalPages;
        this.page += 1;
      } catch (e) {} finally {
        this.fetchWinnerList = false;
      }
    },
    changeAry(ary = [], n = 4) {
      if (!ary.length === 0) return [];
      const len = ary.length;
      const lineNum = len % n === 0 ? len / n : Math.floor(len / n + 1);
      const newAry = [];
      for (let i = 0; i < lineNum; i++) {
        const s = ary.slice(i * n, i * n + n);
        newAry.push(JSON.parse(JSON.stringify(s)));
      }
      return newAry;
    },
    async closeLottery() {
      const { lotteryRecord } = this;
      if (lotteryRecord.conditionType === 'none' && lotteryRecord.status === 'end') {
        try {
          await this.core.lotteryFinish(lotteryRecord.lotteryId);
        } catch (e) {
          throw new Error(e);
        }
      }
      this.$emit('close-lottery', this.lotteryRecord.lotteryId);
    },
    listScroll() {
      const target = this.$refs.winnersListEl;
      const onBottom =
        target.scrollHeight - target.clientHeight - target.scrollTop;
      if (onBottom < 30) {
        this.getWinnersList();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.plv-ia--lottery-winner {
  margin-top: 24px;
  padding: 0 16px;
  text-align: center;
  font-size: 14px;
  position: relative;
  .plv-ia-lottery-template-table-empty {
    overflow: hidden;
  }
  .winner-list__head {
    height: 48px;
    background-color: #edf1f7;
    line-height: 48px;
    justify-content: center;
  }
  .lottery-only-one-list {
    border-bottom: 1px solid #eceff1;
  }
  .plv-ia-lottery__winner__list {
    margin: 20px auto 0;
    height: 356px;
    overflow-y: scroll;

    .winner-list__head {
      height: 48px;
      background-color: #edf1f7;
      line-height: 48px;
      justify-content: center;
    }

    > li {
      height: 48px;
      line-height: 48px;
      display: flex;
      text-align: center;
      background-color: #f8f8fb;

      > span {
        color: #546e7a;
        width: 124px;
        margin: 0 26px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .lottery-only-one-list {
      border-bottom: 1px solid #eceff1;
    }

    li:nth-child(even) {
      background-color: #fff;
    }
  }
}

</style>
